import { useEffect } from 'react';
import { isWeb, navigationRef } from '@helpers';

export const useStopTourOnNavigation = (isActive: boolean, stopTour: () => void, isGlobalTourActive = false) => {
  useEffect(() => {
    if (!isWeb || !isActive || isGlobalTourActive) {
      return;
    }

    const currentRouteName = navigationRef?.current?.getCurrentRoute()?.name;
    let lastRouteName = currentRouteName;

    const unsubscribe = navigationRef?.current?.addListener('state', () => {
      const newRouteName = navigationRef?.current?.getCurrentRoute()?.name;
      if (lastRouteName && newRouteName && lastRouteName !== newRouteName) {
        stopTour();
      }
      lastRouteName = newRouteName;
    });

    return () => {
      unsubscribe?.();
    };
  }, [isActive, stopTour]);
};
